<template>
  <div>
    <div class="con-tab-ejemplo">
      <div class="vx-row">
        <div class="vx-col w-full vx-coll-fixed-hight text-center">
          <vs-table :data="suretyDetails">
            <template slot="thead">
              <vs-th><span class="ml-auto mr-auto">{{ $t('sections.accounting.dataForm.tableSuretyDetail.no') }}</span></vs-th>
              <vs-th><span class="ml-auto mr-auto">{{ $t('sections.accounting.dataForm.tableSuretyDetail.name') }}</span></vs-th>
              <vs-th><span class="ml-auto mr-auto">{{ $t('sections.accounting.dataForm.tableSuretyDetail.parents') }}</span></vs-th>
              <vs-th><span class="ml-auto mr-auto">{{ $t('sections.accounting.dataForm.tableSuretyDetail.phone') }}</span></vs-th>
              <vs-th><span class="ml-auto mr-auto">{{ $t('sections.accounting.dataForm.tableSuretyDetail.mobile') }}</span></vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="index" v-for="(res, index) in data">
                <vs-td :data="(index+1)">
                  {{ (index+1) }}
                </vs-td>
                <vs-td>
                  <p class="text-left">{{ fullName(res.surety) }}</p>
                </vs-td>
                <vs-td>
                  <feather-icon :icon=" res.parents === true ? 'CheckIcon' : 'XIcon'" :class=" res.parents === true ? 'text-success' : 'text-danger'"></feather-icon>
                </vs-td>
                <vs-td>
                  {{ phone(res.surety) }}
                </vs-td>
                <vs-td>
                  {{ mobile(res.surety) }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
const { mapState: mapAccountingState} = createNamespacedHelpers('Accounting');

export default {
  props: ['manage'],
  computed:{
    ...mapAccountingState([
      'status',
      'suretyDetails',
    ]),
    suretyFullName(){
      let prefix = ""
      if(this.contract.callHistoriesReceivedBy.prefix){prefix = this.contract.callHistoriesReceivedBy.prefix.nameTh}
      let callHistoriesReceivedBy = prefix+this.contract.callHistoriesReceivedBy.name+" "+this.contract.callHistoriesReceivedBy.surname
      return `${callHistoriesReceivedBy} กำลังติดตามงานดังกล่าว เวลา ${this.convFormatDateTime(this.contract.callHistoriesReceivedAt)}`
    },
  },
  methods: {
    fullName (res){
      let prefix = ""
      if(res.prefix){
        prefix = res.prefix.nameTh
      }
      return prefix+res.name+" "+res.surname;
    },
    phone (res){
      return res.phone;
    },
    mobile (res){
      return res.mobile;
    },
    email (res){
      return res.email;
    },
  }
}
</script>
<style scoped>
  .vx-coll-fixed-hight{
    display:block;
    width:100%;
    height:400px;
    overflow: auto;
  }
</style>
